import { headerBlank } from "./questions/move";

export async function getWorksheetNames(searchType?: string): Promise<string[]> {
  try {
    return await Excel.run(async (context) => {
      const sheets = context.workbook.worksheets;
      sheets.load("items/name");
      await context.sync();
      const sheetNames = sheets.items.map((sheet) => sheet.name);

      let filteredSheetNames = [];

      if (searchType == "form") {
        // N2に"調査票入稿フォーム"があるシートに絞る
        // "調査票入稿フォーム" が N2 にあるシート名を取得
        for (const name of sheetNames) {
          const sheet = context.workbook.worksheets.getItem(name);
          const range = sheet.getRange("N2");
          range.load("values");
          await context.sync(); // range の読み込みを反映
          if (range.values[0][0].includes("調査票")) {
            filteredSheetNames.push(name);
          }
        }
      } else if (searchType == "item") {
        for (const name of sheetNames) {
          if (name.includes("項目一覧")) {
            filteredSheetNames.push(name);
          }
        }
      } else {
        // それ以外は全てのシート名を取得
        filteredSheetNames = sheetNames;
      }
      return filteredSheetNames;
    });
  } catch (error) {
    if (error instanceof OfficeExtension.Error) {
      console.error("OfficeExtension エラー:", error.debugInfo);
    } else {
      console.error("一般的なエラー:", error);
    }
    // throw error; // 必要に応じて再スロー
    return [];
  }
}

export async function getActiveSheetName(): Promise<string> {
  try {
    return await Excel.run(async (context) => {
      const sheet = context.workbook.worksheets.getActiveWorksheet();
      sheet.load("name");

      await context.sync();

      return sheet.name;
    });
  } catch (error) {
    if (error instanceof OfficeExtension.Error) {
      console.error("OfficeExtension エラー:", error.debugInfo);
    } else {
      console.error("一般的なエラー:", error);
    }
    // throw error; // 必要に応じて再スロー
    return "";
  }
}

export const bufferRows = 3;

export async function copySheet(sheetName: string): Promise<string> {
  const unixTime = Math.floor(Date.now() / 1000);
  const copiedSheetName = `${sheetName}_${unixTime}`;

  await Excel.run(async (context) => {
    const sheet = context.workbook.worksheets.getItem(sheetName);
    const copiedSheet = context.workbook.worksheets.add(copiedSheetName);
    const usedRange = sheet.getRange("B1:Z10000");
    // const usedRange = sheet.getUsedRange();
    usedRange.load(["values", "formulas", "format", "rowCount", "columnCount"]);
    await context.sync();

    copiedSheet.getRange("B1").copyFrom(
      usedRange,
      Excel.RangeCopyType.all,
      false, // skipBlanks
      false // transpose
    );
    await context.sync();

    const rowCount = usedRange.rowCount;
    const colCount = usedRange.columnCount;

    const rowRanges = [];
    const colRanges = [];

    // 行の高さをコピー
    for (let i = 0; i < rowCount; i++) {
      const row = sheet.getRangeByIndexes(i, 0, 1, 1);
      row.load("height");
      rowRanges.push(row);
    }

    // 列の幅をコピー
    for (let j = 0; j < colCount; j++) {
      const col = sheet.getRangeByIndexes(0, j, 1, 1);
      col.load("width");
      colRanges.push(col);
    }

    await context.sync();

    // 行の高さを適用
    for (let i = 0; i < rowCount; i++) {
      const targetRow = copiedSheet.getRangeByIndexes(i, 0, 1, 1);
      targetRow.setRowProperties([
        {
          format: {
            rowHeight: rowRanges[i].height,
          },
        },
      ]);
    }

    // 列の幅を適用
    for (let j = 0; j < colCount; j++) {
      const targetCol = copiedSheet.getRangeByIndexes(0, j, 1, 1);
      targetCol.setColumnProperties([
        {
          format: {
            columnWidth: colRanges[j].width,
          },
        },
      ]);
    }
    await context.sync();
  });

  return copiedSheetName;
}

export async function focusCell(rangeText: string, sheetName?: string) {
  Excel.run(async (context) => {
    let sheet = undefined;

    if (sheetName) {
      sheet = context.workbook.worksheets.getItem(sheetName);
    } else {
      sheet = context.workbook.worksheets.getActiveWorksheet();
    }

    if (!sheet) {
      throw new Error("指定されたシートが見つかりません。");
    }
    const range = sheet.getRange(rangeText);
    range.select();

    await context.sync();
  });
}

export async function clearRange(
  context: Excel.RequestContext,
  sheet: Excel.Worksheet,
  rangeAddress: string
) {
  const targetRange = sheet.getRange(rangeAddress);
  targetRange.clear(Excel.ClearApplyTo.contents);
  await context.sync();
}

export async function fixColumnCValues(editSheet: string) {
  // ExcelのC列を、関数ではなく値に直す
  await Excel.run(async (context) => {
    const sheet = context.workbook.worksheets.getItem(editSheet);
    const range = sheet.getRange(`C${headerBlank + 1}:C9999`);
    range.load("values");
    await context.sync();
    // 値貼り付けにする
    range.values = range.values.map((row) => [row[0]]);
    await context.sync();
  });
}
